import React from 'react';

const ButtonLoader = ({ text, className, wrapperClass }) => {
  const buttonText = text || 'Loading...';

  const btnClass = `spinner-border spinner-border-sm me-1 ${className}`;

  return (
    <div className={`d-flex justify-content-center align-items-center ${wrapperClass}`}>
      <span className={btnClass} />{" "}
      {buttonText}
    </div>
  );
};

export default ButtonLoader;
